import { getServerRequest, patchServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const cargarOficiosEntrantesService = async(page, search, filtro, tipo) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/entrantes?page=${page}&search=${search}&filter=${filtro}&words=${tipo}`;
    return await getServerRequest(url, config);
}

export const cargarOficioEntranteByIdService = async(idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/entrante/${idOficio}`;
    return await getServerRequest(url, config);
}

export const obtenerHistoricoEntranteByIdService = async (idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/entrante/${idOficio}/historico`;
    return await getServerRequest(url, config);
}

export const modificarHistoricoEntranteByIdService = async (idOficio, data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/entrante/${idOficio}/historico`;
    return await patchServerRequest(url, data, config);
}

export const getEtiquetaService = async (data) => {
    const url = `${httpURL}/etiqueta`;
    const config = { responseType: 'blob' };
    return await getServerRequest(url, config);
}
